import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["onLocationChange", "onPlaceSelect", "inputProps"];
import * as React from 'react';
import * as ReactDom from 'react-dom';
import cn from 'classnames';
import { safeInvoke } from '../../../../library';
import { IconLocation, IconSearch, IconClose } from '../../../../icons';
import { Map, Marker } from '../../../map';
import { Button } from '../../../button';
import { LocationSelect } from './location-select';
import { Field } from '../../field';
import { Controls, Control } from '../../control';
var locationSelectMapClasses = {
  MAIN: 'location-select-map',
  OVERLAY: 'location-select-map__overlay',
  QUERY_BAR: 'location-select-map__query-bar'
};
export var LocationSelectMap = function LocationSelectMap(props) {
  var _React$useState = React.useState('1'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    markerId = _React$useState2[0],
    setMarkerId = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    inputValue = _React$useState4[0],
    setInputValue = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    showSearch = _React$useState6[0],
    setShowSearch = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isLocationSet = _React$useState8[0],
    setIsLocationSet = _React$useState8[1];
  var mapApi = React.useRef();
  var centerMapButtonRef = React.useRef();
  function makeCenterMarkerControl(map) {
    var controlUI = document.createElement('div');
    controlUI.classList.add('map-control-group');
    controlUI.title = 'Recenter the marker';
    var controlButton = document.createElement('div');
    controlButton.classList.add('map-control-button', '-icon');
    controlUI.appendChild(controlButton);
    ReactDom.render(React.createElement(IconLocation, null), controlButton);
    centerMapButtonRef.current = controlButton;
    return controlUI;
  }
  ;
  function makeSearchControl(map) {
    var controlUI = document.createElement('div');
    controlUI.classList.add('map-control-group');
    controlUI.title = 'Search for an address';
    var controlButton = document.createElement('div');
    controlButton.classList.add('map-control-button');
    controlUI.appendChild(controlButton);
    ReactDom.render(React.createElement("span", null, React.createElement(IconSearch, null), " Search"), controlButton);
    controlButton.addEventListener('click', function () {
      setShowSearch(true);
    });
    return controlUI;
  }
  ;
  function panToLocation() {
    if (props.location && mapApi.current) {
      mapApi.current.panTo(props.location);
    }
  }
  ;
  React.useEffect(function () {
    if (!!props.location) {
      setIsLocationSet(true);
    }
    ;
  }, [props.location]);
  React.useEffect(function () {
    if (isLocationSet && mapApi.current && props.location) {
      mapApi.current.panTo(props.location);
    }
  }, [isLocationSet, props.location]);
  React.useEffect(function () {
    if (centerMapButtonRef.current) {
      centerMapButtonRef.current.addEventListener('click', panToLocation);
    }
    return function () {
      var _centerMapButtonRef$c;
      (_centerMapButtonRef$c = centerMapButtonRef.current) === null || _centerMapButtonRef$c === void 0 || _centerMapButtonRef$c.removeEventListener('click', panToLocation);
    };
  }, [props.location]);
  var handleMapReady = function handleMapReady(map) {
    mapApi.current = map;
    var centerControl = makeCenterMarkerControl(map);
    var searchControl = makeSearchControl(map);
    map.controls[google.maps.ControlPosition.RIGHT_TOP].push(centerControl);
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(searchControl);
    if (props.location) {
      map.panTo(props.location);
      map.setZoom(17);
    }
  };
  var handleMarkerDragEnd = function handleMarkerDragEnd(options, marker, e) {
    var position = marker.getPosition();
    safeInvoke(props.onLocationChange, position ? position.toJSON() : null);
  };
  var handleInputUpdate = function handleInputUpdate(field, value) {
    setInputValue(value + '');
  };
  function handlePlaceSelect(location) {
    var gApi = window.google;
    if (!gApi || !mapApi.current) return;
    var placeService = new gApi.maps.places.PlacesService(mapApi.current);
    placeService.getDetails({
      placeId: location.place_id,
      fields: ['address_components', 'geometry']
    }, function (result) {
      var _result$geometry;
      if (result !== null && result !== void 0 && (_result$geometry = result.geometry) !== null && _result$geometry !== void 0 && _result$geometry.location) {
        var _mapApi$current, _mapApi$current2;
        var position = result.geometry.location.toJSON();
        setMarkerId(location.place_id);
        setShowSearch(false);
        setInputValue('');
        (_mapApi$current = mapApi.current) === null || _mapApi$current === void 0 || _mapApi$current.panTo(position);
        (_mapApi$current2 = mapApi.current) === null || _mapApi$current2 === void 0 || _mapApi$current2.setZoom(17);
        safeInvoke(props.onLocationChange, position);
      }
      safeInvoke(props.onPlaceSelect, result);
    });
  }
  ;
  function handleSearchClose() {
    setShowSearch(false);
  }
  ;
  var onLocationChange = props.onLocationChange,
    onPlaceSelect = props.onPlaceSelect,
    inputProps = props.inputProps,
    mapProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn(locationSelectMapClasses.MAIN, "-".concat(props.shape));
  return React.createElement("div", {
    className: classNames
  }, React.createElement(Map, _extends({}, mapProps, {
    onReady: handleMapReady
  }), !props.location ? null : React.createElement(Marker, {
    key: markerId,
    position: props.location,
    draggable: true,
    onDragend: handleMarkerDragEnd
  })), props.location && !showSearch ? null : React.createElement("div", {
    className: locationSelectMapClasses.OVERLAY
  }, React.createElement(Field, {
    className: locationSelectMapClasses.QUERY_BAR
  }, React.createElement(Controls, {
    isCombined: true
  }, React.createElement(Control, null, React.createElement(LocationSelect, _extends({
    field: "location",
    before: React.createElement(IconSearch, null),
    placeholder: "Find Address...",
    density: "relaxed",
    apiKey: props.apiKey,
    value: inputValue,
    onUpdate: handleInputUpdate,
    onLocationSelect: handlePlaceSelect,
    isDisabled: props.isDisabled
  }, props.inputProps))), isLocationSet && React.createElement(Control, {
    span: "shrink"
  }, React.createElement(Button, {
    density: "relaxed",
    intent: "primary",
    onClick: handleSearchClose
  }, React.createElement(IconClose, null)))))));
};
LocationSelectMap.defaultProps = {
  shape: 'rounded'
};